module.exports = __webpack_public_path__ + "img/ico11.b0a86dac.svg";